import Marquee from "react-fast-marquee";
import { Asterisk } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

export const EditorialMarquee = () => {
  const { t } = useLanguage();
  const words = [t("marquee.1"), t("marquee.2"), t("marquee.3"), t("marquee.4"), t("marquee.5")];

  return (
    <div data-testid="editorial-marquee" className="border-y border-[#262626] py-8">
      <Marquee speed={32} gradient={false}>
        {words.concat(words).map((w, i) => (
          <span key={i} className="mx-8 flex items-center gap-16">
            <span className="whitespace-nowrap font-syne text-4xl font-bold uppercase tracking-tight text-[#F2F2F2] md:text-6xl">
              {w}
            </span>
            <Asterisk className="h-10 w-10 text-[#FF3333]" />
          </span>
        ))}
      </Marquee>
    </div>
  );
};
